/** @param {Record<string, unknown>} prev @param {Record<string, unknown>} patch */
export function patchAcmeInsuranceRenewalDemoMessage(prev, patch) {
  return { ...prev, ...patch }
}

/** @param {Function} setMessagesByThreadId @param {string} tid @param {string} pendingId @param {Record<string, unknown>} patch */
export function updatePendingAcmeInsuranceRenewalDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchAcmeInsuranceRenewalDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}
